import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type StaffMemberDeletionFailedAction = {
	type: 'STAFF_MEMBER_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): StaffMemberDeletionFailedAction => ({
	type: 'STAFF_MEMBER_DELETION_FAILED',
	payload,
});
